export { AccelerationIcon } from './acceleration'
